import { Effect, call, put } from 'redux-saga/effects';

import { uiReducer } from '../reducers/ui.reducer.ts';

export function* withLoading<T>(key: string, saga: () => Generator<Effect, T, T>): Generator<Effect, T, T> {
  try {
    yield put(uiReducer.actions.setLoading({ key, isLoading: true }));
    return yield call(saga);
  } finally {
    yield put(uiReducer.actions.setLoading({ key, isLoading: false }));
  }
}
